module.exports = __webpack_public_path__ + "static/media/settings.362cbe7d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/settings.svg
// module id = 879
// module chunks = 21